import {
  Box,
  Breadcrumbs,
  Container,
  Link as MuiLink,
  Typography,
} from "@mui/material";
import { CATEGORY_IMAGES } from "../assets/images";
import ShareActions from "../components/common/ShareActions";

const CategoryHeader = ({ cityName, state, category }) => {
  const bgImage = CATEGORY_IMAGES[category] || CATEGORY_IMAGES.tourist;

  return (
    <Box
      sx={{
        position: "relative",
        mb: { xs: 3, md: 4 },
        borderBottomLeftRadius: { xs: 28, md: 36 },
        borderBottomRightRadius: { xs: 28, md: 36 },
        overflow: "hidden",

        /* FULL IMAGE */
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* LEFT GRADIENT FOR TEXT ONLY */}
      <Box
        sx={{
          background: {
            xs: "linear-gradient(180deg, rgba(13,59,102,0.75), rgba(13,59,102,0.4))",
            md: "linear-gradient(90deg, rgba(13,59,102,0.75) 0%, rgba(13,59,102,0.35) 55%, rgba(13,59,102,0.1) 100%)",
          },
          py: { xs: 2.5, md: 3.5 },
          px: { xs: 2, md: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              maxWidth: 560,
              color: "var(--color-sunshine)",
            }}
          >
            {/* Breadcrumb */}
            <Breadcrumbs
              sx={{
                mb: 1,
                fontSize: 13,
                color: "rgba(250,240,202,0.9)",
                textTransform: "capitalize",
              }}
            >
              <MuiLink underline="hover" color="inherit" href="/">
                Home
              </MuiLink>
              <MuiLink underline="hover" color="inherit" href="/city">
                Cities
              </MuiLink>
              <Typography color="inherit">{cityName}</Typography>
            </Breadcrumbs>

            {/* Title */}
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: "1.9rem", md: "2.4rem" },
                lineHeight: 1.15,
                mb: 0.6,
                textShadow: "0 2px 6px rgba(0,0,0,0.55)",
                color: "#F4D35E",
              }}
            >
              {cityName}
            </Typography>

            {/* Accent */}
            <Box
              sx={{
                width: 44,
                height: 3,
                bgcolor: "var(--color-bliss)",
                borderRadius: 2,
                mb: 1,
              }}
            />

            {/* Subtitle */}
            <Typography
              sx={{
                fontSize: { xs: 13, md: 14 },
                color: "rgba(250,240,202,0.95)",
                textShadow: "0 1px 3px rgba(0,0,0,0.45)",
              }}
            >
              Discover trusted {category} across {cityName}, {state} — curated
              to help you find what you need quickly.
            </Typography>
          </Box>
          <ShareActions
            title={`Best ${category} in ${cityName} | NearbyGuide`}
            text={`Explore top ${category.toLowerCase()} in ${cityName}, ${state}.`}
          />
        </Container>
      </Box>
    </Box>
  );
};

export default CategoryHeader;
